<template>
  <el-select :disabled="disabled" filterable v-model="useModel" :clearable="true" placeholder="Select" v-loading="isLoading">
    <el-option v-for="status in statusList" :value="status.id" :label="status.description" :key="status.id">
    </el-option>
  </el-select>
</template>

<script>
// Not currently in use
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  props: {
    inputModel: {
      default: 0
    },
    clearable: {
      default: false
    },
    disabled: {
      default: false
    }
  },
  data () {
    return {
      statusList: Array,
      isLoading: true
    }
  },
  computed: {
    useModel: {
      get: function () {
        return this.inputModel
      },
      set: function (modifiedValue) {
        this.$emit('input', modifiedValue)
      }
    }
  },
  methods: {
    fetchStatusList () {
      this.isLoading = true
      var call = '/getAllPEAStatuses'
      this.$axios.get(call).then(response => {
        const unsortedList = response.data
        const sortedList = unsortedList.sort((a, b) => (a.description.toLowerCase() > b.description.toLowerCase()) ? 1 : -1)
        this.statusList = sortedList
        this.isLoading = false
      }).catch(reject => {
        this.isLoading = false
        helperMethods.showNotification(this.$parent, 'Error getting Status List', reject.body, 'error', 30000, '')
      })
    }
  },
  created () {
    this.fetchStatusList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
